export default __webpack_public_path__ + "static/media/1.818e42f2.png";